export default __webpack_public_path__ + "static/media/ecom.fd2fccb5.jfif";